import { LastName } from '@dreryk/person-name-common-api';

import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

type LastNameFieldProps = {
   readonly register: FormContextValues['register'];
};

const LastNameField = (props: LastNameFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register('lastName', {
            required: true,
            maxLength: LastName.MAX_LENGTH,
         })}
         label={'common:lastName'}
         testId={'lastName'}
      />
   );
};

export { LastNameField };
